import React from 'react'

import type { IArtistListItem } from '~/components/blocks/ArtistsList/hooks'

import AllSiteArtists from '~~/siteAllArtists.json'

import ArtistsHead from '../../components/blocks/ArtistsHead/ArtistsHead'
import type { TArtistPopular } from '../../components/blocks/ArtistsIndexList/ArtistsIndexList'
import ArtistsIndexList from '../../components/blocks/ArtistsIndexList/ArtistsIndexList'
import ArtistsList from '../../components/blocks/ArtistsList/ArtistsList'

import styles from './ArtistsContainer.module.css'

export interface ArtistsContainerProps {
  popularArtistsList?: TArtistPopular[]
  fallbackData?: IArtistListItem[]
  querySlug?: string
}

export default function ArtistsContainer({
  popularArtistsList,
  fallbackData,
  querySlug,
}: ArtistsContainerProps) {
  // // retrieve all artists from sanity, use as fallback data
  const allPossibleArtists = AllSiteArtists

  return (
    <div className={styles.base}>
      <ArtistsIndexList defaultArtistList={popularArtistsList || []} />

      <ArtistsHead
        artistList={allPossibleArtists as any}
        isIndex={querySlug === undefined}
      />

      <ArtistsList fallbackData={fallbackData} querySlug={querySlug} />
    </div>
  )
}
